import { z } from 'zod';
import { SChatwootContact } from './contact';
import { SChatwootConversation } from './conversation';
import { SChatwootMessageAttachment } from './message-attachment';

export const SChatwootMessageCreatedMessage = z.object({
  id: z.number(),
  content: z.string().nullable(),
  account_id: z.number(),
  inbox_id: z.number(),
  conversation_id: z.number(),
  message_type: z.number(),
  created_at: z.number(),
  updated_at: z.string(),
  private: z.boolean(),
  status: z.string(),
  source_id: z.null(),
  content_type: z.string(),
  content_attributes: z.object({}),
  sender_type: z.string(),
  sender_id: z.number(),
  external_source_ids: z.object({}),
  additional_attributes: z.object({}),
  processed_message_content: z.string().nullable(),
  sentiment: z.object({}),
  conversation: SChatwootConversation,
  echo_id: z.string().optional(),
  sender: SChatwootContact,
  attachments: z.array(SChatwootMessageAttachment).optional(),
  performer: SChatwootContact.optional(),
});
export type TChatwootMessageCreatedMessage = z.infer<
  typeof SChatwootMessageCreatedMessage
>;
